import React from 'react';

const ProgressCircle = ({ progress, className, color }) => {
    const size = 32;
    const strokeWidth = 5;
    const center = size / 2;
    const radius = center - strokeWidth;
    const arcLength = 2 * 3.14 * radius;
    const arcOffset = arcLength * (1 - progress);

    return (
        <div className={`${className}`}>
            <svg
                className="progressCircle"
                style={{ transform: 'rotate(-90deg)' }}
                height={`${size}`}
                width={`${size}`}
            >
                <circle
                    className="progressCircle-track"
                    cy={`${center}px`}
                    cx={`${center}px`}
                    r={`${radius}px`}
                    strokeWidth={`${strokeWidth}px`}
                    stroke="#ddd"
                    fill="transparent"
                />
                <circle
                    className="progressCircle-indication"
                    cy={`${center}px`}
                    cx={`${center}px`}
                    r={`${radius}px`}
                    strokeWidth={`${strokeWidth}px`}
                    strokeDasharray={`${arcLength}`}
                    strokeDashoffset={`${arcOffset}px`}
                    stroke={color}
                    fill="transparent"
                />
            </svg>
            {/*<svg*/}
            {/*    width={32}*/}
            {/*    height={32}*/}
            {/*    viewBox="0 0 32 32"*/}
            {/*    xmlns="http://www.w3.org/2000/svg"*/}
            {/*    transform="rotate(-90)"*/}
            {/*>*/}
            {/*    <circle*/}
            {/*        r={12}*/}
            {/*        cx={16}*/}
            {/*        cy={16}*/}
            {/*        stroke="#e0e0e0"*/}
            {/*        strokeWidth={5}*/}
            {/*        fill="transparent"*/}
            {/*    />*/}
            {/*    <circle*/}
            {/*        r={12}*/}
            {/*        cx={16}*/}
            {/*        cy={16}*/}
            {/*        stroke={color}*/}
            {/*        strokeWidth={5}*/}
            {/*        strokeDasharray="75px"*/}
            {/*        fill="transparent"*/}
            {/*        style={{*/}
            {/*            strokeDashoffset: `${75 - parseInt(75*progress)}px`*/}
            {/*        }}*/}
            {/*    />*/}
            {/*</svg>*/}
        </div>
    );
};

export default ProgressCircle;
